const fixedMainCats = {
  partsService: 58,
  postService: 16,
  maintenanceService: 2
};

export default fixedMainCats;
